module.exports = __webpack_public_path__ + "img/0911_cover.c64e4db3.jpg";